export const emptyFunc = (a) => a;
